import { Instruction } from '@/types';
import { UI } from '@/Components/UI';

type InstructionsListProps = {
    instructions: Instruction[];
};

export const InstructionsList = ({ instructions }: InstructionsListProps) => {
    return (
        <div className={'flex flex-col gap-4'}>
            {instructions.map((instruction, index) => (
                <UI.Card key={index} className={'grid grid-cols-[3em_1fr] gap-3'}>
                    <div
                        className={'flex items-center justify-center aspect-square w-full rounded-full bg-primary-container text-on-primary-container font-bold font-inter'}>
                        {index + 1}
                    </div>

                    <div className={'justify-center flex flex-col gap-4'}>
                        {instruction.description}

                        {instruction.image && (
                            <UI.Image
                                image={instruction.image}
                                alt={instruction.description}
                                className={'aspect-video md:aspect-24/9 w-full rounded-lg'} />
                        )}
                    </div>
                </UI.Card>
            ))}
        </div>
    );
};
